import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import { PosterPrint } from '../../components/PosterPrint';
import { PosterPrintLandingBusiness } from '../PosterPrintLandingBusiness';
import { Clipboard } from '../Clipboard';
import { ShareButton } from '../ShareButtons';
import styles from './style.module.css';
import { ILandingBusiness } from '../../interfaces/ILandingBusiness';

interface IModalPosterPrint {
  modalIsOpen: boolean;
  closeModal: () => void;
  action: any;
  shareUrl?: string;
  actionImagesBase64: any;
  cartazCover?: any;
  clientPrimaryColor: string;
  playerName: string;
  isLandingBusiness?: boolean;
  // LandingBusiness-specific props
  landingBusiness?: ILandingBusiness;
  playerPhone?: string;
  playerPhoto?: string;
  playerRating?: number;
  imagesBase64?: string[];
  showPlayerContact?: boolean;
  loadingPoster?: boolean;
  // Imagens do condomínio (URLs originais, só pra miniatura de seleção da capa)
  condominiumImageUrls?: string[];
  selectedCoverIndex?: number;
  onSelectCoverImage?: (index: number) => void;
}

export function ModalPosterPrint({
  modalIsOpen,
  closeModal,
  action,
  shareUrl,
  actionImagesBase64,
  cartazCover,
  clientPrimaryColor,
  playerName,
  isLandingBusiness = false,
  landingBusiness,
  playerPhone,
  playerPhoto,
  playerRating,
  imagesBase64,
  showPlayerContact,
  loadingPoster = false,
  condominiumImageUrls,
  selectedCoverIndex = 0,
  onSelectCoverImage,
}: IModalPosterPrint) {
  const [logo, setLogo] = useState<string>('');
  const [qrCode, setQrcode] = useState<string>('');
  const [image, setImage] = useState<string>('');
  const [playerPhotoBase64, setPlayerPhotoBase64] = useState<string>('');
  const [isDownloading, setIsDownloading] = useState(false);

  const [indexActiveImage, setIndexActiveImage] = useState(0);

  useEffect(() => {
    if (cartazCover) {
      setLogo(cartazCover.logoImgBase64);
      setQrcode(cartazCover.qrCodeBase64);
      setImage(cartazCover.imgBase64);
      setPlayerPhotoBase64(cartazCover.playerPhotoBase64 || '');
    }
  }, [cartazCover]);

  const generatePDF = () => {
    const postPrintElement: HTMLElement | null =
      document.querySelector('#print');

    if (postPrintElement) {
      setIsDownloading(true);
      html2canvas(postPrintElement, {
        scale: 3,
        logging: false,
        imageTimeout: 0,
      }).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const doc = new jsPDF('p', 'mm', 'a4', true);
        const width = doc.internal.pageSize.getWidth();
        const height = doc.internal.pageSize.getHeight();
        doc.addImage(imgData, 'PNG', 0, 0, width, height);
        doc.save(`${action.actionTitle} - Cadastre-se usando o QR Code.pdf`);
        setIsDownloading(false);
      });
    }
  };

  const generatePNG = () => {
    const postPrintElement: HTMLElement | null =
      document.querySelector('#print');
    if (postPrintElement) {
      setIsDownloading(true);
      html2canvas(postPrintElement, {
        scale: 2.5,
        logging: false,
        imageTimeout: 0,
      }).then((canvas) => {
        const a = document.createElement('a');
        a.href = canvas
          .toDataURL('image/png')
          .replace('image/jpeg', 'image/octet-stream');
        a.download = `cartaz-${Date.now()}.png`;
        a.click();
        setIsDownloading(false);
      });
    }
  };

  const handleImage = (index: number, url: string, id: string) => {
    setIndexActiveImage(index);

    const findAction = actionImagesBase64?.find(
      (action: any) => action && action.actionId === id
    );

    if (findAction && findAction.images) {
      const findImageBase64 = findAction.images.find(
        (img: any) => img.imageUrl === url
      );
      if (findImageBase64) {
        setImage(findImageBase64.imgBase64);
      }
    }

    if (findAction && !findAction.images) {
      const findImageBase64 = actionImagesBase64?.find(
        (img: any) => img.imageUrl === url
      );

      if (findImageBase64) {
        setImage(findImageBase64.imgBase64);
      }
    }
  };

  return (
    <Modal
      open={modalIsOpen}
      onClose={closeModal}
      classNames={{
        modal: styles.modal,
        overlay: styles.overlay,
        closeButton: styles.closeButton,
      }}
    >
      <div className="row">
        <div className="col-sm-12 col-md-6">
          {isLandingBusiness && landingBusiness ? (
            loadingPoster ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  minHeight: 300,
                }}
              >
                <div className="spinner-border text-secondary" role="status">
                  <span className="visually-hidden">Carregando...</span>
                </div>
              </div>
            ) : (
              <PosterPrintLandingBusiness
                landingBusiness={landingBusiness}
                playerName={playerName}
                playerPhone={playerPhone}
                playerPhoto={playerPhotoBase64 || playerPhoto}
                playerRating={playerRating}
                clientLogo={logo}
                color={clientPrimaryColor}
                imagesBase64={imagesBase64}
                qrCode={qrCode}
                showPlayerContact={showPlayerContact}
              />
            )
          ) : (
            clientPrimaryColor &&
            playerName &&
            action &&
            action.images &&
            cartazCover && (
              <PosterPrint
                isMgm={action.conversionType === 'form' ? false : true}
                coverImg={image}
                logo={logo}
                qrCode={qrCode}
                color={clientPrimaryColor}
                title={action.actionTitle}
                name={playerName}
                description={`Para saber mais, cadastre-se usando o QR Code abaixo.`}
              />
            )
          )}
        </div>
        <div className="col-sm-12 col-md-6">
          <div className="mt-5 px-4">
            {isLandingBusiness &&
              condominiumImageUrls &&
              condominiumImageUrls.length > 1 && (
                <div className="my-3">
                  <span className="fw-semibold">
                    Passo 1 - Escolha a imagem de capa do cartaz (fotos do
                    condomínio).
                  </span>
                  <div className="mt-3">
                    <div className="row" id="boxImageChange">
                      {condominiumImageUrls.map(
                        (url: string, index: number) => (
                          <div className="col" key={url}>
                            <div
                              className={`${styles.boxImageChange} ${
                                index === selectedCoverIndex
                                  ? styles.active
                                  : ''
                              }`}
                              data-image={url}
                              data-index={index}
                              onClick={() => onSelectCoverImage?.(index)}
                            >
                              <img src={url} alt="" />
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
              )}
            {!isLandingBusiness &&
              ((action && !action.defaultImagePoster) ||
                (action.defaultImagePoster === 'false' && (
                  <div className="my-3">
                    <span className="fw-semibold">
                      Passo 1 - Escolha uma das imagens abaixo.
                    </span>
                    <div className="mt-3">
                      <div className="row" id="boxImageChange">
                        {action && action.images && action.images.length > 0
                          ? action.images.map((image: any, index: number) => {
                              return (
                                <div className="col">
                                  <div
                                    className={`${styles.boxImageChange} ${
                                      index === indexActiveImage
                                        ? styles.active
                                        : ''
                                    }`}
                                    data-image={image.url}
                                    data-index={index}
                                    onClick={() =>
                                      handleImage(index, image.url, action.id)
                                    }
                                  >
                                    <img src={image.url} alt="" />
                                  </div>
                                </div>
                              );
                            })
                          : ''}
                      </div>
                    </div>
                  </div>
                )))}
            <div className="mb-3 mt-3 mt-md-0">
              {(isLandingBusiness &&
                condominiumImageUrls &&
                condominiumImageUrls.length > 1) ||
              (action && !action.defaultImagePoster) ||
              action.defaultImagePoster === 'false' ? (
                <span className="fw-semibold">
                  Passo 2 - Clique para imprimir o cartaz ou criar imagem para
                  divulgar
                </span>
              ) : (
                <span className="fw-semibold">
                  Clique para imprimir o cartaz ou criar imagem para divulgar
                </span>
              )}
            </div>
            <div className="row">
              <div className="col">
                <div className="d-grid">
                  <button
                    className="btn btn-danger d-flex align-items-center justify-content-center"
                    onClick={generatePDF}
                    disabled={isDownloading}
                  >
                    {isDownloading ? (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <i className="material-icons-outlined me-3 fs-5">
                        picture_as_pdf
                      </i>
                    )}
                    Arquivo
                  </button>
                  <span className="text-center tiny-text">*Para impressão</span>
                </div>
              </div>
              <div className="col">
                <div className="d-grid">
                  <button
                    className="btn btn-primary d-flex align-items-center justify-content-center"
                    onClick={generatePNG}
                    disabled={isDownloading}
                  >
                    {isDownloading ? (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <i className="material-icons-outlined me-3 fs-5">image</i>
                    )}
                    Imagem
                  </button>
                  <span className="text-center tiny-text">
                    *Para redes sociais
                  </span>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-sm-12 col-md-8 col-xl-6">
                <span>Compartilhe via</span>
                <div className="my-3">
                  <ShareButton action={action} />
                </div>
              </div>
              <div className="col-sm-12 col-md-8 col-xl-6">
                <span>Ou copie o link</span>
                <div className="my-3">
                  <Clipboard
                    actionId={action}
                    shareUrl={shareUrl ? shareUrl : ''}
                  />
                </div>
              </div>
            </div>
            <hr />
            <p className="tiny-text">* Aguarde o download do arquivo</p>
          </div>
        </div>
      </div>
    </Modal>
  );
}
